import React from "react";
import "gantt-task-react/dist/index.css";
import { ViewMode } from "gantt-task-react";
import { Tabs, Tab, Theme, makeStyles } from "@mui/material";
type ViewSwitcherProps = {
    isChecked: boolean;
    onViewListChange: (isChecked: boolean) => void;
    onViewModeChange: (viewMode: ViewMode) => void;
};

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
    onViewModeChange,
    onViewListChange,
    isChecked
}) => {
    const [value, setValue] = React.useState("Month");

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        switch (newValue) {
            case "Day":
                onViewModeChange(ViewMode.Day);
                break;
            case "Week":
                onViewModeChange(ViewMode.Week);
                break;
            case "Month":
                onViewModeChange(ViewMode.Month);
                break;
            case "Year":
                onViewModeChange(ViewMode.Year);
                break;
            default:
                setValue("Day");
                onViewModeChange(ViewMode.Day);
                break;
        }
    };

    const bgActive = {
        '&.Mui-selected': {
            background: '#E9F3FF',
            borderRadius: "5px"
        }
    }

    return (
        <Tabs value={value} onChange={handleChange} aria-label="รูปแบบการแสดงข้อมูล" TabIndicatorProps={{
            style: {
                background: "transparent"
            }
        }}>
            <Tab sx={bgActive} label="วัน" value={"Day"} />
            <Tab sx={bgActive} label="สัปดาห์" value={"Week"} />
            <Tab sx={bgActive} label="เดือน" value={"Month"} />
            {/* <Tab sx={bgActive} label="ปี" value={"Year"} /> */}
        </Tabs>
    );
};